import * as React from "react";

function SvgCancelled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={4} y={4.5} width={8} height={8} rx={2} fill="#63666A" />
    </svg>
  );
}

export default SvgCancelled;
